/**
 * @description Creates a store for testing
 */
export class TestStore {
  /**
   * Creates a new instance of the TestStore class
   */
  constructor() {
    this.store = new Map();
  }

  /**
   * @description Stores the data in the store
   * @param {string} key A key, which allows to access the data 
   * @param {object} value The data, which should be stored
   */
  setItem( key, value ) {
    this.store.set( key, value );
  }

  /**
   * @description Gets the stored data for the specified key
   * @param {string} key A key, which was used store the data
   * @returns {object} Returns the stored Data for the specified key
   */
  getItem( key ) {
    return this.store.get( key );
  }

  /**
   * @description Removes the stored data for the specified key
   * @param {string} key A key, which was used store the data
   */
  removeItem( key ) {
    this.store.delete( key );
  }

  /**
   * @description Removes all data
   */
  clear() {
    this.store.clear();
  }
}